import { render, staticRenderFns } from "./GameDetailView.vue?vue&type=template&id=32953158&scoped=true&"
import script from "./GameDetailView.vue?vue&type=script&lang=js&"
export * from "./GameDetailView.vue?vue&type=script&lang=js&"
import style0 from "./GameDetailView.vue?vue&type=style&index=0&id=32953158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32953158",
  null
  
)

export default component.exports